if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    // 商品加入购物车的操作
    class ProductForm extends HTMLElement {
      constructor() {
        super();
        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }
      _initAddToCart2(){
        this.$previouslyFocusedElement = $(':focus');
        this.selectors = {
          productForm: '[data-product-form]',
        }
        var $data = $(this.selectors.productForm, this.$container);
        this._addItemToCart($data);
      }
      //加入购物车的底层方法
      _addItemToCart(data) {
        
        $('.loading').css('display', 'block');
        var productType=document.getElementById('liquidData').innerHTML;
        //图片校验
        if(productType==='Wall Clocks'||productType==='layer'){
          if($('.left').find('img').length != $('.upload-images').find('.avatar-inputs').length){
            console.log(cartValidate("cropblanket"))
            if(!cartValidate("cropblanket")){
              this.$previouslyFocusedElement.focus();
              var errorMessage = "Please upload all photos";
              // this._showErrorMessage(errorMessage);
              // this._handleButtonLoadingState(false);
              $('.product-form__error-message-wrapper--hidden').css('display','flex')
              $('.product-form__error-message').html(errorMessage)
              return false
            }
          }
        }else if($('.left').find('img').length != $('.upload-images').find('input').length){
          console.log(cartValidate("cropblanket"),'cartValidate("cropblanket")')
          if(!cartValidate("cropblanket")){
            this.$previouslyFocusedElement.focus();
            var errorMessage = "Please upload all photos";
            // this._showErrorMessage(errorMessage);
            // this._handleButtonLoadingState(false);
            $('.product-form__error-message-wrapper--hidden').css('display','flex')
            $('.product-form__error-message').html(errorMessage)
            return false
          }
        }
        
  
        // 有文本框 验证
        if($('.text-item-wrap').length){
          if(!textValidate()){
            this.$previouslyFocusedElement.focus();
            var errorMessage = "Please fill all text";
            // this._showErrorMessage(errorMessage);
            // this._handleButtonLoadingState(false);
            $('.product-form__error-message-wrapper--hidden').css('display','flex')
            $('.product-form__error-message').html(errorMessage)
            return false
          }
        }
        
        if($('.sunzi-modal-mask ').length){
          if($('#is-cube-upload').val()==''){
            var errorMessage = "Please customize your rubik's cube";
            // this._showErrorMessage(errorMessage);
            // this._handleButtonLoadingState(false);
            return false
          }
        }
  
        //vip
        if(document.getElementById('vipstatus').innerHTML==='1'){
          cateTempVipHtml();
        }
  
        // //选择相框验证
        // if($('#check_frame').is(':checked')){
        //   if($('#photo_frame').val()==''){
        //     this.$previouslyFocusedElement.focus();
        //     this._handleButtonLoadingState(false);
        //     $(".frame-option").addClass("validation-warning");
        //     return false
        //   }else{
        //     $(".frame-option").removeClass("validation-warning");
        //   }
        // }
        let number=$('.quantity__input').val();
        if(number<1){
          $('.product-form__error-message-wrapper--hidden').css('display','flex')
          $('.product-form__error-message').html('Quantity must be 1 or more')
          return
        }else{
          $('.product-form__error-message-wrapper--hidden').css('display','none')
        }
        let values0 = $(data).serializeArray();
        var appendFormData=$('#appendForm').serializeArray();
        let value=values0.concat(appendFormData)
        let dataArray = {};
        //将上传的图片加入到properties里面
        $.each(value, function (index, item) {
          /* 处理图片数组 */
          if(item.name === 'properties[Preview]' && item.value.indexOf('{') !== -1){
            var picList = JSON.parse(item.value);
            Object.keys(picList).forEach(function(key){
              dataArray['properties[Preview' + (parseInt(key)+1) + ']'] = picList[key]
            })
          } else if (item.name === 'properties[OriginalPhoto]' && item.value.indexOf('{') !== -1) {
            var picList = JSON.parse(item.value);
            Object.keys(picList).forEach(function(key){
              dataArray['properties[Original' + (parseInt(key)+1) + ']'] = picList[key]
            })
          } else if (item.name === 'properties[HD]' && item.value.indexOf('{') !== -1) {
            var picList = JSON.parse(item.value);
            Object.keys(picList).forEach(function(key){
              dataArray['properties[HD' + (parseInt(key)+1) + ']'] = picList[key]
            })
          } else {
            dataArray[item.name] = item.value;
          }
        });

        //S3CopyObject权限失效，文件直接存orders
        // var fileList = []
        // for(var key in dataArray){
        //   if(dataArray[key].indexOf('http')>-1&&dataArray[key].indexOf('temporary')>-1){
        //     var index = dataArray[key].indexOf('temporary')
        //     var arr = dataArray[key].trim().split('temporary')
        //     arr.splice(1,0,'orders')
        //     var str = arr.join('')
        //     var file = dataArray[key].substr(index)
        //     fileList.push(file)
        //     //替换图片路径
        //     dataArray[key] = str
        //   }
        // }
        // var fileName
        // var newPath
        // for(var i=0;i<fileList.length;i++){
        //   fileName = fileList[i].split('/')[1]
        //   newPath = 'orders/'+ fileName
        //   // 添加到购物车图片copy到真实位置
        //   S3CopyObject('giftinone','/giftinone/'+fileList[i],newPath)
        // }
      
        
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];
        const oldformData = new FormData(this.form);
        // 创建一个新的 FormData 对象并遍历当前值
        const formData = new FormData();
        // 获取输入框的值
        const inputValue = document.getElementById("quantityNumber").value;  
        oldformData.forEach((value, key) => {
            if (key === "quantity") {
                // 修改 quantity 的值
                formData.append(key, inputValue);
            } else {
                // 保留其他键值对
                formData.append(key, value);
            }
        });

        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          for (let key in dataArray) {
            if(key.includes('properties')){
              formData.append(key, dataArray[key]);
            }
          }
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;
        // 使用 for...of 迭代 FormData 的 entries 
        
        //商品加入购物车的接口请求
        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
              $('.loading').css('display', 'none');
              if(document.getElementById('vipstatus').innerHTML==='1'){
                boxAddToCart(inputValue);
              }
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }
      //加入购物车的事件
      onSubmitHandler(evt) {
        evt.preventDefault();
        
        //加入购物车
        this._initAddToCart2();
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}

this.selectors = {
  SKU: '.variant-sku',
}


/**
 *  pet Cart 表单验证
 * */
function cartValidate(jsproducttype) {
  var index=0;
  if(jsproducttype=='cropblanket'){
    $('.uploadfont').each(function(){ 
      // 在这里对每个元素执行操作 
      if ($(this).find('img').length > 0) {
        $(this).find('.left').css('border','1px solid #ccc'); 
        // 如果该节点下存在img元素 
        console.log('Found an img element within .your-class'); 
      } else { 
        $(this).find('.left').css('border', '1px solid #f00000');
        index++;
        // 如果该节点下不存在img元素 
        console.log('No img element found within .your-class'); 
      }
    });
  }
  if(index>0){
    return false
  }else{
    return true
  }
}
/**
 *  text Cart 
 */
function textValidate() {
  if($('.text-item-wrap').length){
    var fillAll = true
    $('.text-item-wrap').find('input[type ="text"]').each(function(){
      if($(this).val()===''){
        $(this).css('border','1px solid #f00000');
        fillAll = false
      }else{
        $(this).css('border','1px solid #ccc');
        // return true
      }
    });
    return fillAll
  }
}
/**
 * @description: s3复制临时桶内容
 * @param {
* targetBucket:String,
* targetSource:String,
* newPath:String} 
* @return {type} 
* @author: Mengyu Xia
*/
function S3CopyObject(targetBucket,targetSource,newPath){
const spacesEndpoint = new AWS.Endpoint('s3-accelerate.amazonaws.com');
const s3 = new AWS.S3({
    endpoint: spacesEndpoint,
    accessKeyId: 'AKIAQR47IXWA47U6COG2',
    secretAccessKey: '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',
    region: "us-west-1"
});
var params = {
  Bucket: targetBucket,
  CopySource: targetSource, 
  Key: newPath,
  ACL: "public-read"
};
s3.copyObject(params,function(err, data){
  if (err) console.log(err, err.stack); // an error occurred
  else     console.log('copy success'); 
})
}
